<template >
  <!-- 已经选中的形成的列表  -->
  <div class="selected_line_wrap">
    <div class="selectedLine" v-for="(item, i) in showChoseTickets" :key="i">
      <!-- 序号 -->
      <span class="select first">{{ `第${item.index}程` }}</span>
      <!-- 城市 -->
      <span class="select second">
        {{ item.departureCityName }}
        <img class="arrow_icon" src="~@/assets/img/arrow_icon1.png" />
        {{ item.destinationCityName }}
      </span>
      <!-- 航班 -->
      <span class="select third">{{
        item.airlineCompany + item.flightNo
      }}</span>
      <!-- 机场 -->
      <span class="select forth">
        {{ item.departureAirportName + item.terminalDeparture }}
        <img class="arrow_icon" src="~@/assets/img/arrow_icon1.png" />
        {{ item.arrivalAirportName + item.terminalArrival }}
      </span>
      <!-- 起始时间 -->
      <span class="select fifth">
        {{ item.departureTime }} - {{ item.arrivalTime }}
        <span class="addDay" v-show="item.isAddDay">+1</span>
      </span>
      <!-- 经历时间 -->
      <span class="select sixth">
        <img class="time_icon" src="~@/assets/img/time_icon.png" alt="" />
        {{ formatTime(item.duration) }}
      </span>
      <!-- 经停 -->
      <span v-if="item.stopInformation">
        <span class="select seventh" :title="` 经停 ${item.stopInformation} `">
          经停<span class="spot"> .</span> {{ item.stopInformation }}
        </span>
      </span>
      <span v-else>
        <span class="select seventh"></span>
      </span>
      <!-- 操作 -->
      <div class="select operate" @click="drop(i)">
        <img src="~@/assets/img/edit.png" />
      </div>
    </div>
  </div>
</template>


<script>
import flightTickets from "../../utils/flightTickets";
export default {
  name: "selected",
  methods: {
    drop: function (index) {
      // debugger;
      let obj = new flightTickets();
      obj.dropTickets(index, this.$store);
    },
    formatTime(min) {
      let hour = parseInt((min / 60).toString());
      let hourStr = hour > 1 ? `${hour}h` : "";
      let minute = min % 60;
      let minStr = minute > 0 ? `${minute}m` : "";
      return hourStr + minStr;
    },
  },
  mounted: function () {},
  computed: {
    showChoseTickets() {
      let showTicket = this.$store.getters.getChoseTicket;
      return showTicket;
    },
  },
};
</script>
<style lang="scss">
.selected_line_wrap {
  padding: 22px;
  padding-top: 20px;
  padding-bottom: 0px;
}
.selectedLine {
  color: #333;
  margin: 5px 0px;
  line-height: 46px;
  background: #fcfcfc;
  border: 1px solid #eeeeee;
  font-size: 14px;
  .arrow_icon {
    width: 14px;
    position: relative;
    top: -4px;
  }
  .select {
    padding: 0px 18px;
  }
  .first {
    color: #fff;
    background: #2dbb55;
    display: inline-block;
    padding: 0px 18px;
  }
  .second {
    border-right: 1px solid #eeeeee;
    height: 100%;
    display: inline-block;
  }
  .fifth {
    // width: 100px;
    display: inline-block;
    .addDay {
      font-size: 12px;
      color: #999;
      position: relative;
      top: -6px;
    }
  }
  .sixth {
    .time_icon {
      position: relative;
      top: 3px;
      width: 16px;
    }
  }
  .seventh {
    .spot {
      position: relative;
      top: -3px;
    }
  }
  .operate {
    float: right;
    // margin-right: 10px;
    cursor: pointer;
    img {
      width: 20px;
      position: relative;
      top: 3px;
    }
  }
}
</style>


